import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';
export function registerLocationInputResourceBundleDe(i18next: i18n): void {
  i18next.addResourceBundle('de', 'record-it-components', {
    input: {
      LocationInput: {
        noValue: 'keine Koordinaten gesetzt'
      }
    }
  } as Partial<CustomTypeOptions['resources']['record-it-components']>, true);
}